/* France Éternelle — main.js */
(function() {
  'use strict';

  /* Mobile menu toggle */
  var menuToggle = document.querySelector('.header__menu-toggle');
  var mobileMenu = document.querySelector('.header__mobile-nav');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      mobileMenu.classList.toggle('is-open');
    });
  }

  /* Generate ToC from H2 headings, then observe for active state */
  var tocList = document.getElementById('toc-list');
  var content = document.querySelector('.article__content');

  if (tocList && content) {
    var h2s = content.querySelectorAll('h2');
    var tocEntries = [];

    /* Add "Introduction" as first ToC item */
    var introLi = document.createElement('li');
    var introA = document.createElement('a');
    introA.className = 'toc__link is-active';
    introA.href = '#';
    introA.textContent = 'Introduction';
    introA.addEventListener('click', function(e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    introLi.appendChild(introA);
    tocList.appendChild(introLi);
    tocEntries.push({ el: null, link: introA, isIntro: true });

    h2s.forEach(function(h2, i) {
      if (!h2.id) h2.id = 'section-' + (i + 1);

      /* Use data-toc attribute for short sidebar title, fallback to full text */
      var text = h2.getAttribute('data-toc') || h2.textContent.trim();
      if (text.length > 50) text = text.substring(0, 47) + '...';

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'toc__link';
      a.href = '#' + h2.id;
      a.textContent = text;
      li.appendChild(a);
      tocList.appendChild(li);

      tocEntries.push({ el: h2, link: a });
    });

    /* Highlight active ToC item on scroll */
    if (tocEntries.length > 1) {
      /* Track which section is active based on scroll position */
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            tocEntries.forEach(function(t) { t.link.classList.remove('is-active'); });
            var match = tocEntries.find(function(t) { return t.el === entry.target; });
            if (match) match.link.classList.add('is-active');
          }
        });
      }, { rootMargin: '-80px 0px -60% 0px' });

      /* When user scrolls above first H2, activate Introduction */
      window.addEventListener('scroll', function() {
        var firstH2 = tocEntries.find(function(t) { return t.el !== null; });
        if (firstH2 && firstH2.el.getBoundingClientRect().top > window.innerHeight * 0.4) {
          tocEntries.forEach(function(t) { t.link.classList.remove('is-active'); });
          var intro = tocEntries.find(function(t) { return t.isIntro; });
          if (intro) intro.link.classList.add('is-active');
        }
      }, { passive: true });

      tocEntries.forEach(function(t) {
        if (t.el) observer.observe(t.el);
      });
    }
  }
})();

/* === SEM 6 POLISH — Reading progress === */
(function(){
  var bar = document.querySelector('.reading-progress');
  if (!bar) return;
  var fill = bar.querySelector('.reading-progress__bar');
  if (!fill) return;
  var ticking = false;
  function update(){
    var h = document.documentElement;
    var b = document.body;
    var scrollTop = h.scrollTop || b.scrollTop;
    var scrollHeight = (h.scrollHeight || b.scrollHeight) - h.clientHeight;
    var pct = scrollHeight > 0 ? Math.min(100, Math.max(0, (scrollTop / scrollHeight) * 100)) : 0;
    fill.style.width = pct + '%';
    bar.setAttribute('aria-valuenow', Math.round(pct));
    ticking = false;
  }
  function onScroll(){
    if (!ticking){ requestAnimationFrame(update); ticking = true; }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();

/* === SEM 8 — Custom Events GA4 (Olivier Sanz-Ortega) === */
/* Wrapper feTrack : marche même si GA4 pas chargé (dataLayer fallback) */
(function() {
  'use strict';
  window._fePendingEvents = window._fePendingEvents || [];
  window.feTrack = function(name, params) {
    params = params || {};
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    } else {
      window._fePendingEvents.push({name: name, params: params});
    }
  };
  /* Flush pending events when GA4 loads */
  window.addEventListener('load', function() {
    setTimeout(function() {
      if (typeof window.gtag === 'function' && window._fePendingEvents.length) {
        window._fePendingEvents.forEach(function(e) { window.gtag('event', e.name, e.params); });
        window._fePendingEvents = [];
      }
    }, 1000);
  });

  /* === Event 1-3 : read_25 / read_50 / read_complete (article scroll) === */
  if (document.querySelector('.article__content, .article')) {
    var milestones = {25: false, 50: false, 100: false};
    var ticking = false;
    function checkScroll() {
      var h = document.documentElement;
      var b = document.body;
      var scrollTop = h.scrollTop || b.scrollTop;
      var scrollHeight = (h.scrollHeight || b.scrollHeight) - h.clientHeight;
      var pct = scrollHeight > 0 ? Math.round((scrollTop / scrollHeight) * 100) : 0;
      if (pct >= 25 && !milestones[25]) { milestones[25] = true; window.feTrack('read_25', { article_handle: location.pathname }); }
      if (pct >= 50 && !milestones[50]) { milestones[50] = true; window.feTrack('read_50', { article_handle: location.pathname }); }
      if (pct >= 95 && !milestones[100]) { milestones[100] = true; window.feTrack('read_complete', { article_handle: location.pathname }); }
      ticking = false;
    }
    window.addEventListener('scroll', function() {
      if (!ticking) { requestAnimationFrame(checkScroll); ticking = true; }
    }, { passive: true });
  }

  /* === Event 4 : outbound_click === */
  document.addEventListener('click', function(e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    try {
      var url = new URL(a.href, location.href);
      if (url.hostname && url.hostname !== location.hostname && !url.hostname.endsWith('.franceeternelle.fr')) {
        window.feTrack('outbound_click', {
          link_url: a.href,
          link_domain: url.hostname,
          link_text: (a.textContent || '').trim().substring(0, 80),
          source_path: location.pathname
        });
      } else if (url.pathname && url.pathname !== location.pathname) {
        /* Event 5 : internal_link_click */
        window.feTrack('internal_link_click', {
          link_url: url.pathname,
          link_text: (a.textContent || '').trim().substring(0, 80),
          source_path: location.pathname
        });
      }
    } catch(_) {}
  }, true);

  /* === Event 6 : newsletter_submit === */
  var newsletterForms = document.querySelectorAll('form[action*="contact"], .footer-premium__newsletter-form, form[id*="newsletter"]');
  newsletterForms.forEach(function(f) {
    f.addEventListener('submit', function() {
      window.feTrack('newsletter_submit', {
        location: f.closest('footer') ? 'footer' : (f.closest('aside') ? 'sidebar' : 'inline'),
        source_path: location.pathname
      });
    });
  });

  /* === Event 7 : atlas_marker_click === */
  document.addEventListener('click', function(e) {
    var marker = e.target.closest('[data-atlas-marker], .atlas-marker, .maplibregl-marker');
    if (marker) {
      window.feTrack('atlas_marker_click', {
        marker_id: marker.getAttribute('data-atlas-marker') || marker.getAttribute('data-id') || '',
        marker_label: marker.getAttribute('aria-label') || marker.textContent.trim().substring(0, 80),
        source_path: location.pathname
      });
    }
  }, true);

  /* === Event 8 : silo_filter_change === */
  var blogChips = document.querySelectorAll('.blog-page__chip');
  blogChips.forEach(function(c) {
    c.addEventListener('click', function() {
      window.feTrack('silo_filter_change', {
        filter_value: c.textContent.trim(),
        source_path: location.pathname
      });
    });
  });
  var blogSort = document.getElementById('blog-sort');
  if (blogSort) {
    blogSort.addEventListener('change', function() {
      window.feTrack('silo_filter_change', {
        filter_type: 'sort',
        filter_value: blogSort.value,
        source_path: location.pathname
      });
    });
  }
})();

/* === SEM 8+ — Reading time indicator === */
(function() {
  var content = document.querySelector('.article__content, .article');
  if (!content) return;
  var byline = document.querySelector('.fe-author, .article__byline, .article__meta');
  if (!byline) return;
  if (byline.querySelector('.fe-reading-time')) return; // already added
  var text = content.textContent || '';
  var words = text.trim().split(/\s+/).filter(Boolean).length;
  if (words < 50) return; // skip very short articles
  var minutes = Math.max(1, Math.round(words / 220)); // ~220 mots/minute
  var span = document.createElement('span');
  span.className = 'fe-reading-time';
  span.textContent = ' · Lecture ' + minutes + ' min';
  byline.appendChild(span);
})();
